import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../../app/guards'
import { EditProductPage } from '../../../../features/catalog/product-pages'
import {
  attributesQueryOptions,
  categoriesQueryOptions,
  unitsQueryOptions,
} from '../../../../features/catalog/queries'
import { taxRatesQueryOptions } from '../../../../features/finance/queries'

export const Route = createFileRoute('/_app/products/$productId/edit')({
  staticData: { crumb: 'productEdit' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'products.update'),
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(unitsQueryOptions)
    void context.queryClient.prefetchQuery(categoriesQueryOptions)
    void context.queryClient.prefetchQuery(attributesQueryOptions)
    void context.queryClient.prefetchQuery(taxRatesQueryOptions)
  },
  component: EditProductPage,
})
